import { fabric } from 'fabric';
import { CanvasDataTypes, getGroupedItemByName } from '../../../utils/canvas-utils';
import { handleTemporaryTextEditor } from './handle-temporary-text-editor';

/**
 * Handler for when mouse target on canvas is a photoTextzone
 * @param photoTextZone selected phototextzone
 * @param canvas
 * @param isDisplayZoomEnabled
 * @param isSnSButtonsEna
 */
export type HandlePhototextzoneSelectionProps = {
  photoTextZone: fabric.Group;
  canvas: fabric.Canvas;
  isDisplayZoomEnabled: boolean;
  isSnSButtonsEnabled: boolean;
};

export const handlePhototextzoneSelection = ({
  photoTextZone,
  canvas,
  isDisplayZoomEnabled,
  isSnSButtonsEnabled,
}: HandlePhototextzoneSelectionProps): void => {
  const originalText = getGroupedItemByName(CanvasDataTypes.PhotoZoneTextbox, photoTextZone) as fabric.Textbox;
  // if the photoTextZone has text, handle temporary text editor to edit the text
  if (originalText.text) {
    handleTemporaryTextEditor({
      currentCanvas: canvas,
      isMobileZoomEnabled: isDisplayZoomEnabled,
      zone: photoTextZone,
      sasDynamicButtons: isSnSButtonsEnabled,
    });
  }
};
